<template>
  <div class="review-item">
    <div class="avatar-section">
      <div class="platform-avatar">
        <img :src="getPlatformAvatar(review.platform)" :alt="review.name" height="25px">
      </div>
      <div class="avatar" :style="{ 'background-image': 'url(' + review.avatar + ')' }"></div>
    </div>
    <div class="rating-section">
      <span v-if="review.platform === 'Google'" class="star-rating">
        <i class="material-icons" v-for="(star, i) in getStarCount(review.starRating)" :key="i">{{star}}</i>
      </span>
      <span v-else class="recommendation">
        recommends
      </span>
      <small>{{review.comment}}</small>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ReviewListItem",
    props: {
      review: Object,
    },
    methods: {
      getPlatformAvatar(platform) {
        return platform === 'Facebook' ? 'https://cdn.chatavise.com/social/f_logo_RGB-Blue_58.png' : 'https://cdn.chatavise.com/social/Google-Reviews-icon.png';
      },
      getStarCount(rating) {
        switch (rating) {
          case 5:
            return ['star', 'star', 'star', 'star', 'star'];
          case 4:
            return ['star', 'star', 'star', 'star'];
          case 3:
            return ['star', 'star', 'star'];
          case 2:
            return ['star', 'star'];
          case 1:
            return ['star'];
          default:
            return [];
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .review-item {
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: 70px auto;

    .avatar-section {
      display: flex;
      align-items: center;
      align-self: baseline;

      .platform-avatar {
        z-index: 11;
        height: 35px;
        width: 35px;
        border-radius: 50%;
        background-color: var(--background-secondary);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .avatar {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-size: cover;
        margin-left: -10px;
        z-index: 10;
      }
    }

    .rating-section {
      display: flex;
      flex-direction: column;

      .star-rating {
        display: flex;
        margin-bottom: 8px;

        i {
          font-size: 20px;
          color: #e7711b;
        }
      }

      .recommendation {
        margin-bottom: 8px;
        font-size: 14px;
        font-style: italic;
        color: #385898;
      }

      small {
        font-style: italic;
      }
    }

  }
</style>
